<template lang="pug">
  main
    NavBarGrupos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Autotanques Documentados en IRGE ~ {{ grupo }} &nbsp
              i.fas.fa-clipboard-check
        .columns.is-vcentered
          .column.is-3-desktop.is-3-tablet
            b Seleccione una fecha:
            .field
              .control
                flat-pickr(
                  v-model='fechaJornada'
                  :config="config"
                  class="input"
                )
          .column.is-2-desktop.is-1-tablet
            a.button.is-dark.is.rounded.is-bottom-cv(:href="linkReporte" v-show="hayDatos" target="_blank")
              i.far.fa-file-pdf
              | &nbsp Generar Reporte
        .columns
          .column.is-12.has-text-centered(v-show="hayDatos")
            .table-responsive
              table#tbFacturas.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Embarque
                    th Autotanque
                    th Destino
                    th Transportista
                    th Carta Porte
                    th(v-show="verFacturas")
                      | Factura
                    th(v-show="verFacturas")
                      | Xml
                tbody
                  tr(v-for="(data, index) in embarques" :key="data.idEmbarque")
                    td {{ index + 1 }}
                    td {{ data.numeroDeEmbarque }}
                    td {{ data.pg }}
                    td {{data.nombreDestinatario}}
                    td {{data.nombrePorteador}}
                    td
                      a.button.is-danger.is-small.is-rounded(@click="getLink(data)")
                        i.fas.fa-file-alt
                    td(v-show="verFacturas")
                      a.button.is-info.is-small.is-rounded(@click="downloadFactura(data.noEmbarque)")
                        i.fas.fa-file-alt
                    td(v-show="verFacturas")
                      a.button.is-success.is-small.is-rounded(@click="downloadXml(data.noEmbarque)")
                        i.fas.fa-file-excel
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros para ésta Búsqueda.
        .columns.column-blanco  
</template>

<script>
  import Loader from '../../shared/Loader.vue'
  import NavBarGrupos from '../layout/NavBarGrupos.vue'
  import sca_irgeServices from '../../../services/sca/irge'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'
  import facturasServices from '../../../services/facturas/facturas'

  export default {
    name: 'CargasGrupos',
    components: { Loader, NavBarGrupos, flatPickr },
    data() {
      return {
        isLoading: true,
        fechaJornada: moment().format('YYYY-MM-DD'),
        hayDatos: false,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        grupo: '',
        embarques: [],
        hash: '',
        tipoReporte: '',
        linkReporte: '',
        verFacturas: false
      }
    },
    watch: {
      fechaJornada () {
        this.isLoading = true
        this.obtenerDocumentados()
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerDocumentados()
      },
      obtenerDocumentados() {
        var currentUrl = window.location.hostname
        console.log(this.fechaJornada)
        console.log(this.fechaF)

        switch (this.userLogin.cargo) {
          case '880':
            // Propangol
            this.grupo = 'PROPANGOL'
            this.hash = '3fb41274cbce12cf8257bbb583e0b965'
            this.tipoReporte = 'comer'
            this.verFacturas = true
            sca_irgeServices.getDocumentados_Comercializadora(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })

            break
          case '881':
            // Movenergy
            this.grupo = 'MOVENERGY'
            this.tipoReporte = 'comer'
            this.hash = '957afb8032400ebae0f9e42065a63681'
            sca_irgeServices.getDocumentados_Comercializadora(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })
            break
          case '882':
            // Nieto
            this.grupo = 'NIETO'
            this.tipoReporte = 'grupo'
            this.verFacturas = true
            this.hash = 'ec76fa938f52f44a663975e238a79c1f'
            sca_irgeServices.getDocumentados_Grupo(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })

            break
          case '883':
            // Metropolitano
            this.grupo = 'METROPOLITANO'
            this.tipoReporte = 'grupo'
            this.hash = '11de5c1141c3b807addf94716348d462'
            sca_irgeServices.getDocumentados_Grupo(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })
            break
          case '884':
            // Uribe
            this.grupo = 'URIBE'
            this.tipoReporte = 'grupo'
            this.hash = 'ae2581e424ee70456febbe3fdd8a586d'
            sca_irgeServices.getDocumentados_Grupo(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })
            break
          case '885':
            // Mabarak
            this.grupo = 'MABARAK'
            this.tipoReporte = 'grupo'
            this.hash = '769b163982cabca7324bb5406d10d4d8'
            sca_irgeServices.getDocumentados_Grupo(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })
            break
          case '886':
            // Soni
            this.grupo = 'SONIGAS'
            this.tipoReporte = 'subgrupo'
            this.hash = 'd994ddf24432a0c239c9963a5930707a'
            this.verFacturas = true
            sca_irgeServices.getDocumentados_SubGrupo(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })
            break
          case '8822':
            // Soni
            this.grupo = 'GLOBAL'
            this.tipoReporte = 'subgrupo'
            this.hash = 'a6d442dae2346b2ea18127c70e7a9bc4'
            sca_irgeServices.getDocumentados_SubGrupo(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })
            break
          case '8823':
            // Soni
            this.grupo = 'METRO-NIETO'
            this.tipoReporte = 'subgrupo'
            this.hash = 'e54bcf1594438947c5ebf47705b0b8bb'
            sca_irgeServices.getDocumentados_SubGrupo(this.fechaJornada, this.hash)
              .then( res => {
                this.embarques = res
                if (this.embarques.length > 0) {
                  this.hayDatos = true
                  this.getReporte()
                } else {
                  this.hayDatos = false
                }
                this.isLoading = false
              })
            break
            
            break
          default:
            break
        }
      },
      // downloadCartaPorte(emb) {
      //   var currentUrl = window.location.hostname;
      //   console.log(currentUrl);
      //   console.log(emb);
      //   open(`https://${currentUrl}/SCA_Tuxpan/reportes/cartaPorteD.php?embarque=${emb}`);
      // },
      getLink (emb) {
        var currentUrl = window.location.hostname
        console.log(currentUrl)
        this.link = `http://10.122.40.189/servidores/reportes/cartaPorte_Irge.php?emb=${emb.noEmbarque}&n=${emb.numeroDeEmbarque}` 
        console.log(this.link)
        window.open(this.link, '_blank')
      },
      downloadFactura (emb) {
        var currentUrl = window.location.hostname
        console.log(currentUrl)

        let api_storage = ''
        let link = ''
        facturasServices.getFactura_Id(emb)
          .then( res => {
            let fact = {}
            if (res.length > 0) {
              fact = Object.assign(fact, res[0])
              console.log(fact)
              if (currentUrl === '10.121.50.145' || currentUrl === 'localhost') {
                api_storage = 'http://10.121.51.133'
                link = `${api_storage}/Facturas/windowDownload.php?ruta=${fact.ruta_Fact}`
                open(link)
              } else {
                api_storage = `https://${currentUrl}`
                link = `${api_storage}/Facturas/ubuntuDownload.php?ruta=${fact.ruta_Fact}`
                open(link)
              }
              //open(`http://${api_storage}/SCA_Tuxpan/Facturas/${fact.ruta_Fact}`)
            } else {
              console.log('No se encontro la factura')
            }
          })
      },
      downloadXml(emb) {
        var currentUrl = window.location.hostname
        console.log(currentUrl)

        let api_storage = ''
        let link = ''
        facturasServices.getFactura_Id(emb)
          .then( res => {
            let fact = {}
            if (res.length > 0) {
              fact = Object.assign(fact, res[0])
              console.log(fact)
              if (currentUrl === '10.121.50.145' || currentUrl === 'localhost') {
                api_storage = 'http://10.121.50.130'
                link = `${api_storage}/Facturas/${fact.ruta_Xml}`
                open(link)
              } else {
                api_storage = `https://${currentUrl}`
                link = `${api_storage}/Facturas/${fact.ruta_Xml}`
                //link = `${api_storage}/Facturas/ubuntuDownload.php?ruta=${fact.ruta_Xml}`
                open(link)
              }
              //open(`http://${api_storage}/SCA_Tuxpan/Facturas/${fact.ruta_Fact}`)
            } else {
              console.log('No se encontro el Xml')
            }
          })
      },
      getReporte() {
        var currentUrl = window.location.hostname
        switch (this.tipoReporte) {
          case 'comer':
            this.linkReporte = `http://10.122.40.189/servidores/IRGE_Reporte_CD_Comercializadora.php?h=${this.hash}&f=${this.fechaJornada}`
            break
          case 'grupo':
            this.linkReporte = `http://10.122.40.189/servidores/IRGE_Reporte_CD_Grupo.php?h=${this.hash}&f=${this.fechaJornada}`
            break
          case 'subgrupo':
            this.linkReporte = `http://10.122.40.189/servidores/IRGE_Reporte_CD_SubGrupo.php?h=${this.hash}&f=${this.fechaJornada}`
            break
        
          default:
            break
        }
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
    ...mapState(['logueado', 'userLogin'])
    },
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .button.is-dark.is.rounded.is-bottom-cv {
    margin-top: 25px;
  }
</style>


// WEBPACK FOOTER //
// src/components/grupos_Componentes/IRGE/CargasGruposIRGE.vue